import React from 'react';
import Footer from '../layouts/footer';
import Header from '../layouts/header';
import { Link } from 'react-router-dom/dist';

const items = [
    { to: '/profile', icon: 'fa-user', title: 'Profile', desc: 'View & edit your profile' },
    { to: '/phonebook', icon: 'fa-phone', title: 'Phonebook', desc: 'Find colleagues' },
    { to: '/leaves', icon: 'fa-file', title: 'Leaves', desc: 'Apply & view leaves' },
    { to: '/attendance', icon: 'fa-business-time', title: 'Attendance', desc: 'Check-in / out' },
    { to: '/payroll', icon: 'fa-hand-holding-dollar', title: 'Payroll', desc: 'Payslips & history' },
    { to: '/team', icon: 'fa-users', title: 'My Team', desc: 'Team overview' },
];

export default function Dashboard() {
    return (
        <>
            <Header />

            <main className="container root py-4">
                <div className="row g-3 mb-3">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0">Dashboard</h5>
                                <small className="text-muted">Quick actions and shortcuts</small>
                            </div>
                            <div>
                                <Link to="/profile" className="btn btn-outline-secondary btn-sm me-2 mb-2">User Profile</Link>
                                <Link to="/attendance" className="btn btn-brand btn-sm">Mark Attendance</Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row g-3">
                    {items.map((it) => (
                        <div key={it.to} className="col-6 col-md-4">
                            <Link to={it.to} className="text-decoration-none">
                                <div className="card card-modern h-100 dashboard-card">
                                    <div className="card-body">
                                        <div className="me-3 display-icon bg-light">
                                            <i className={`fas ${it.icon} text-brand fa-lg`} />
                                        </div>
                                        <div>
                                            <div className="fw-semibold text-dark">{it.title}</div>
                                            {/* <div className="small text-muted">{it.desc}</div> */}
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </main>

            <Footer />
        </>
    );
}
